module.exports = __webpack_public_path__ + "img/image47.a086d7df.png";